export enum PayoutStatus {
  Pending,
  Approved,
  Rejected,
}
